
import { Action             } from "@/models/action";
import { ActionType         } from "@/models/action.type";

import {PanoramaController} from "@/components/panorama.controller";

export class NavigateLeft extends Action {

  /** the panoramic controller that can actually do stuff for us */
  private readonly _controller : PanoramaController = null;

  /** standard constructor */
  constructor(controller : PanoramaController) {
    super({
      key:   ActionType.PANO_NAVIGATE_LEFT,
      type:  ActionType.PANO_NAVIGATE_LEFT,
      label: 'Jump to Left Panorama',
      icon:  '',
      tip:   ''
    });

    this._controller = controller;
  }

  /** fetch the panoramic controller */
  public controller(): PanoramaController {

    return this._controller;
  }

  /** implement the action */
  public execute() : boolean {

    this._controller.navigateLeft();

    return true;
  }
}
